import { useNavigate } from 'react-router';
import Button from 'react-bootstrap/Button';

import { fetchToken } from './Auth';

export default function SignOutButton() {
  const navigate = useNavigate();

  const signOut = (event) => {
    localStorage.removeItem('temitope');
    navigate('/login');
  };

  return (
    <>
      {fetchToken() ? (
        <Button
          variant="primary"
          onClick={(event) => {
            signOut(event);
          }}
        >
          サインアウト
        </Button>
      ) : (
        <div></div>
      )}
    </>
  );
}
